import i18next from 'i18next';
import * as yup from 'yup';
const expresion = /^[A-Za-z0-9 *ñáéíóúÁÉÍÓÚ_]*$/;
const MIN_PASSWORD_LENGTH = 6;

const validations = yup.object().shape({
  newPassword: yup
    .string()
    .min(MIN_PASSWORD_LENGTH, () => i18next.t('security-password-recovery.validations.newPassword'))
    .trim()
    .matches(expresion, () => i18next.t('common.validations.numbersAndLetters')),
  repeatPassword: yup
    .string()
    .required(() => i18next.t('common.validations.fieldRequired'))
    .trim()
    .test(
      'repeatPassword',
      () => i18next.t('security-password-recovery.validations.passwordEqual'),
      function (value) {
        return value === this.parent.newPassword;
      }
    )
});
export default validations;
